import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useParams, useNavigate, useLocation, Outlet } from "react-router-dom";
import { useNavBarStore } from "../../store/nav-bar-store";
import Assessments from "./assessments/assessments";
import Collections from "./library/collections";
import NavBarLayout from "../../components/nav-bar-layout";
import Overview from "./overview";
import Lectures from "./lectures/lectures";


type TabItem = {
  label: string;
  value: string;
};

const tabs: TabItem[] = [
  { label: "Overview", value: "overview" },
  { label: "Lectures", value: "lectures" },
  { label: "Assessments", value: "assessments" },
  { label: "Library", value: "library" }
];


export default function ClassroomActivity() {
  const { classroom_id } = useParams<{ classroom_id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const { drawerWidth } = useNavBarStore();

  // local storage to get the default tab later!!!
  const currentTab = location.hash.replace("#", "") || "overview";

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    navigate(`#${newValue}`);
  };


  return (
    <NavBarLayout>
      <Box
        sx={{
            display: "flex",
            justifyContent: "center",
            overflowX: "auto",
            overflowY: "hidden",
            flexDirection: "row",
        }}
      >
        <Tabs
            value={currentTab}
            onChange={handleTabChange}
            textColor="primary"
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons="auto"
        >
            {tabs.map((tab) => (
              <Tab key={tab.value} label={tab.label} value={tab.value} />
            ))}
        </Tabs>
      </Box>

      <Box marginTop={2}>
        {currentTab === "overview" && (
          <Overview />
        )}

        {currentTab === "assessments" && (
          <Assessments/>
        )}

        {currentTab === "lectures" && (
          <Lectures/>
        )}


        {currentTab === "library" && (
          <Collections/>
        )}



        
      </Box>
    </NavBarLayout>
  );
}
